require('../../modules/es.array.is-array');
var path = require('../../internals/path');

module.exports = path.Array.isArray;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/is-array.js
// module id = 438
// module chunks = 0